import { Link2Off } from "lucide-react";
import DemoBanner from "./DemoBanner";

export default function ExpiredCard() {
  return (
    <div className="flex min-h-screen flex-col justify-center bg-page px-6 py-6">
      <div className="mx-auto flex w-full max-w-[480px] flex-col items-center text-center">
        <DemoBanner />
        <div className="mt-4 flex h-[72px] w-[72px] items-center justify-center rounded-full bg-slate-100">
          <Link2Off className="h-8 w-8 text-slate-500" />
        </div>
        <h1 className="mt-4 text-xl font-semibold text-ink">Link expired or invalid</h1>
        <p className="mt-1 text-[13px] text-ink-secondary">
          This authorisation link is no longer valid. Please request a new link from your retailer.
        </p>
      </div>
    </div>
  );
}